import html from "../../../images/html5.png";
import css from "../../../images/css.jpg";
import bootstrap from "../../../images/boot.png";
import tailwind from "../../../images/tailwind.avif";
import pyhton from "../../../images/pyhton.png";
import laravel from "../../../images/laravel.png";
import nest from "../../../images/nest.png";
import gitlab from "../../../images/gitlab.png";
import github from "../../../images/github.png";

export const frontendTrackDetail = [
  {
    id: 1,
    title: "HTML",
    name: "Hyper Text Markup Language",
    description:
      "Creating a detailed course information page like Udemy's involves numerous elements and styles, which can be quite extensive. While I can provide you with a basic example, please note that replicating the full functionality and design of a complex platform like Udemy would require more advanced coding and design skills.",
    image: html,
    learning_outcome: [
      "Insert a graphic within a web page.",
      "Personalize web pages using text formatting, graphics, audio, and video elements.",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident knowledge needed!",
      "Define HTML and common terminology related to HTML. Recognize correct HTML syntax. Be able to write a brief, error-free HTML code.",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Author webpages with well-structured HTML and correct CSS layout/styling patterns",
      "Semantic HTML.",
    ],
    course_contents: [
      {
        topic: "Introduction to HTML",
        para:
          "To start using HTML, you'll need a text editor. A text editor is a software program for writing code. Since an HTML file is in standard text format, any basic text editor will work for this tutorial.",
      },
      {
        topic: "HTML Elements and Tags",
        para: "Exploring various HTML elements and their usage. Your first step will be to download a free text editor to use",
      },
      {
        topic: "Building a Web Page",
        para: "Creating a complete web page using HTML.",
      },
    ],
  },
  {
    id: 2,
    title: "CSS",
    name: "Cascading Style Sheets",
    description:
      "Creating a detailed course information page like Udemy's involves numerous elements and styles, which can be quite extensive. While I can provide you with a basic example, please note that replicating the full functionality and design of a complex platform like Udemy would require more advanced coding and design skills.",
    image: css,
    learning_outcome: [
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
    ],
    course_contents: [
      {
        topic: "Introduction to CSS",
        para: "An introduction to Cascading Style Sheets (CSS) and its role in web development.",
      },
      {
        topic: "CSS Selectors and Properties",
        para: "Exploring CSS selectors and properties for styling web pages.",
      },
      {
        topic: "Advanced CSS",
        para: "Advanced CSS topics and techniques for responsive web design.",
      },
    ],
  },
  {
    id: 3,
    title: "Bootstrap",
    name: "Bootstrap Framework",
    description:
      "Creating a detailed course information page like Udemy's involves numerous elements and styles, which can be quite extensive. While I can provide you with a basic example, please note that replicating the full functionality and design of a complex platform like Udemy would require more advanced coding and design skills.",
    image: bootstrap,
    learning_outcome: [
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
    ],
    course_contents: [
      {
        topic: "Introduction to Bootstrap",
        para: "An introduction to the Bootstrap framework for building responsive web pages.",
      },
      {
        topic: "Bootstrap Grid System",
        para: "Understanding the Bootstrap grid system for creating responsive layouts.",
      },
      {
        topic: "Bootstrap Components",
        para: "Exploring Bootstrap components and how to use them in web development.",
      },
    ],
  },
  {
    id: 4,
    title: "Tailwind",
    name: "Tailwind Framework",
    description:
      "Creating a detailed course information page like Udemy's involves numerous elements and styles, which can be quite extensive. While I can provide you with a basic example, please note that replicating the full functionality and design of a complex platform like Udemy would require more advanced coding and design skills.",
    image: tailwind,
    learning_outcome: [
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
      "Become a modern and confident HTML and CSS developer, no prior knowledge needed!",
    ],
    course_contents: [
      {
        topic: "Introduction to Tailwind",
        para: "An introduction to the Tailwind framework for building responsive web pages.",
      },
      {
        topic: "Tailwind Grid System",
        para: "Understanding the Tailwind grid system for creating responsive layouts.",
      },
      {
        topic: "Tailwind Components",
        para: "Exploring Tailwind components and how to use them in web development.",
      },
    ],
  },
];


export const backendTrackDetail = [
  {
    id: 5,
    title: "php-Laravel",
    name: "PHP with Laravel Framework",
    description: "Learn to build web applications using PHP and the Laravel framework for efficient development.",
    image: laravel,
    learning_outcome: [
      "Develop web applications with PHP and Laravel.",
      "Create RESTful APIs.",
      "Implement authentication and authorization.",
      "Work with databases using Eloquent ORM.",
    ],
    course_contents: [
      {
        topic: "Introduction to PHP",
        para: "Get started with PHP and understand its basics."
      },
      {
        topic: "Building Web Applications with Laravel",
        para: "Learn to use Laravel for building modern web applications."
      },
    ]
  },
  {
    id: 6,
    title: "Python",
    name: "Python with Djaongo",
    description: "Learn to build web applications using PHP and the Laravel framework for efficient development.",
    image: pyhton,
    learning_outcome: [
      "Develop web applications with python and Laravel.",
      "Create RESTful APIs.",
      "Implement authentication and authorization.",
      "Work with databases using Eloquent ORM.",
    ],
    course_contents: [
      {
        topic: "Introduction to python",
        para: "Get started with python and understand its basics."
      },
      {
        topic: "Building Web Applications with Laravel",
        para: "Learn to use Laravel for building modern web applications."
      },
    ]
  },
  {
    id: 7,
    title: "Nest JS",
    name: "Nest js Framework",
    description: "Master Python and the Django framework to develop web applications and APIs efficiently.",
    image: nest,
    learning_outcome: [
      "Develop web applications and RESTful APIs with Python and Django.",
      "Create and manage databases using Django ORM.",
      "Implement user authentication and permissions.",
    ],
    course_contents: [
      {
        topic: "Introduction to nest",
        para: "Get started with nest programming language."
      },
      {
        topic: "Web Development with Django",
        para: "Learn to build web applications with Django framework."
      },
    ]
  },
];

export const gitVersionTrackDetail = [
  {
    id: 8,
    title: "GitLab",
    name: "GitLab Version Control",
    description: "Learn to use GitLab for version control and collaboration in software development projects.",
    image: gitlab,
    learning_outcome: [
      "Set up GitLab repositories for version control.",
      "Collaborate with team members using GitLab's features.",
      "Manage code branches and merge requests.",
      "Automate continuous integration and deployment with GitLab CI/CD.",
    ],
    course_contents: [
      {
        topic: "Introduction to GitLab",
        para: "Get started with GitLab and understand its basics."
      },
      {
        topic: "Version Control with Git",
        para: "Learn the fundamentals of Git for version control."
      },
    ]
  },
  {
    id: 9,
    title: "GitHub",
    name: "GitHub Version Control",
    description: "Master GitHub for version control and open-source collaboration in software development projects.",
    image: github,
    learning_outcome: [
      "Create and manage repositories on GitHub.",
      "Collaborate with other developers using GitHub's features.",
      "Contribute to open-source projects on GitHub.",
      "Automate workflows with GitHub Actions.",
    ],
    course_contents: [
      {
        topic: "Introduction to GitHub",
        para: "Get started with GitHub and understand its basics."
      },
      {
        topic: "GitHub Workflows",
        para: "Learn about GitHub workflows and best practices."
      },
    ]
  },
];
